import { AppThunk } from "../app/store";
import { getProgramsNamesForUser, ProgramIdAndName } from "../app/api";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type UpstreamAttributesState = {
  status?: "pending" | "loading" | "finished" | "error";
  values: ProgramIdAndName[];
  error?: unknown;
};

type UpstreamAttributesData = {
  programNameData: UpstreamAttributesState;
};

const UpstreamAttributesInitialData: UpstreamAttributesData = {
  programNameData: { values: [] },
};

const upstreamAttributesData = createSlice({
  name: "upstreamAttributesData",
  initialState: UpstreamAttributesInitialData,
  reducers: {
    getProgramNamesStarted(state) {
      state.programNameData.status = "loading";
    },
    getProgramNamesSuccess(state, action: PayloadAction<ProgramIdAndName[]>) {
      state.programNameData.status = "finished";
      state.programNameData.values = action.payload;
    },
    getProgramNamesFailure(state, action) {
      state.programNameData.status = "error";
      state.programNameData.error = action.payload;
    },
  },
});

export const {
  getProgramNamesStarted,
  getProgramNamesSuccess,
  getProgramNamesFailure,
} = upstreamAttributesData.actions;

export default upstreamAttributesData.reducer;

export const getProgramNames = (): AppThunk => async (dispatch) => {
  try {
    dispatch(getProgramNamesStarted());
    const programNames = await getProgramsNamesForUser();
    dispatch(getProgramNamesSuccess(programNames));
  } catch (err: unknown) {
    const errorMessage = err instanceof Error ? err.message : String(err);
    dispatch(getProgramNamesFailure(errorMessage));
  }
};
